import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_MANAGER_HEADER_ROW_CLASS_NAME = 'TableManagerHeaderRow';

export const TABLE_MANAGER_HEADER_ROW_CLASS_SLOTS = ['root'] as const;

export type TableManagerHeaderRowClassSlot =
	(typeof TABLE_MANAGER_HEADER_ROW_CLASS_SLOTS)[number];

export interface TableManagerHeaderRowClasses {
	root: string;
}

export type TableManagerHeaderRowClassKey = keyof TableManagerHeaderRowClasses;

export const getTableManagerHeaderRowUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_MANAGER_HEADER_ROW_CLASS_NAME, slot);

export const tableManagerHeaderRowClasses = generateUtilityClasses<
	keyof TableManagerHeaderRowClasses
>(TABLE_MANAGER_HEADER_ROW_CLASS_NAME, ['root']);
export default tableManagerHeaderRowClasses;
